import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '@common/services/AuthService/AuthService';

@Injectable()
export class LoginGuardService implements CanActivate {

  constructor(
    private userService: AuthService,
    public router: Router,
  ) {}

  canActivate() {
    const isLoggedIn = !!this.userService.getAccessToken();
    if (isLoggedIn) {
      this.router.navigateByUrl('/dashboard');
    } else {
      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/LoginGuardService/LoginGuardService.ts